import _ from 'underscore';

export function openPopup(url, name, params) {
  var defaultOptions = {
    left: 0,
    top: 0,
    width: 462,
    height: 425,
    scrollbars: 'yes',
    resizable: 'yes',
    location: 'no',
    menubar: 'no',
    status: 'no',
    titlebar: 'no'
  };

  var winSpec = [];
  var viewportCenter = window.screen.width / 2;
  var viewportMiddle = window.screen.height / 2;
  var options = _.extend(defaultOptions, params);
  var settings = _.extend(options, {
    left: Math.floor(viewportCenter - options.width / 2),
    top: Math.floor(viewportMiddle - options.height / 2),
    width: options.width
  });

  _.each(settings, function (val, key) {
    winSpec.push(key + '=' + val);
  });

  return window.open(url, name, winSpec.join(','));
}
